import React, { useState } from 'react';
import styles from './PerformanceInsight.module.scss';
import { Button, Col, Container, Input, Label, Row } from 'reactstrap';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { IoCaretForwardCircleOutline, IoCaretBackCircleOutline } from "react-icons/io5";

const columnsData = [
    { name: "Total Sales", value: "XXXXX" },
    { name: "Customer ratings", value: "4.8 stars" },
    { name: "Return Rate", value: "2%" },
    { name: "Marketing Performance", value: "Campaign Data" },
];

const PerformanceInsight = () => {
    const [selectedOption, setSelectedOption] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        if (event.target.value === 'option1') {
            console.log('Option 1 selected');
        } else if (event.target.value === 'option2') {
            console.log('Option 2 selected');
        } else if (event.target.value === 'option3') {
            console.log('Option 3 selected');
        }
    };

    const reviews = [
        {
            id: 1,
            reviewer: 'James Corden',
            time: 'Just now',
            content: '1 Overall, my experience with Outdoor Adventure Gear was very positive. I would definitely purchase from this seller again and recommend them to others looking for quality outdoor equipment.',
            rating: '5.0',
        },
        {
            id: 2,
            reviewer: 'James Corden',
            time: 'Just now',
            content: '2 Overall, my experience with Outdoor Adventure Gear was very positive. I would definitely purchase from this seller again and recommend them to others looking for quality outdoor equipment.',
            rating: '3.0',
        },
        {
            id: 3,
            reviewer: 'James Corden',
            time: 'Just now',
            content: '3 Another review with positive feedback about Outdoor Adventure Gear and quality service.',
            rating: '2.0',
        },
        {
            id: 4,
            reviewer: 'James Corden',
            time: 'Just now',
            content: '4 Overall, my experience with Outdoor Adventure Gear was very positive. I would definitely purchase from this seller again and recommend them to others looking for quality outdoor equipment.',
            rating: '4.0',
        },
        {
            id: 5,
            reviewer: 'James Corden',
            time: 'Just now',
            content: '5 Another review with positive feedback about Outdoor Adventure Gear and quality service.',
            rating: '5.0',
        },
    ];

    const scrollNext = () => {
        if (currentIndex < reviews.length - 2) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const scrollPrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <div className={styles.mainPerformanceContainer}>
            <h4 className={styles.mainHeading}>Performance Insights</h4>

            <Container fluid className={styles.selectBrandInput}>
                <Label for="brand">Select Brand:</Label>
                <Input
                    type="select"
                    id="brand"
                    value={selectedOption}
                    onChange={handleSelectChange}
                >
                    <option value="">Please select</option>
                    <option value="option1">Option 1</option>
                    <option value="option2">Option 2</option>
                    <option value="option3">Option 3</option>
                </Input>
            </Container>

            <Row className={styles.overviewReviewsRow}>
                <Col sm='12' lg="6" className={styles.brandDetailColumn}>
                    <h5 className={styles.sectionHeading}>Overview</h5>
                    <div className={styles.detailBox}>
                        <h4 className={styles.mainHeading}>ABC Brand</h4>
                        {columnsData?.map((column, index) => (
                            <Row key={index} className={styles.columnDataRow}>
                                <Col className={styles.columnName}>{column.name}:</Col>
                                <Col>{column.value}</Col>
                            </Row>
                        ))}
                    </div>
                </Col>
                <Col sm='12' lg="6" className={styles.recentReviewsColumn}>
                    <h5 className={`${styles.sectionHeading} mt-3 mt-lg-0`}>Recent Reviews</h5>
                    <Row className={styles.reviewsWrapper}>
                        {currentIndex > 0 && (
                            <Col md="1" className={styles.backArrowButton}>
                                <Button className={styles.arrowButton} onClick={scrollPrev}>
                                    <IoCaretBackCircleOutline size={40} />
                                </Button>
                            </Col>
                        )}
                        {reviews.slice(currentIndex, currentIndex + 2).map((review, index) => (
                            <Col key={review.id} className={styles.reviewContentColumn}>
                                <div className={styles.recentReviewHeader}>
                                    <p className={styles.reviewerName}>By {review.reviewer} <span>{review.time}</span></p>
                                </div>
                                <p className={styles.reviewText}>{review.content}</p>
                                <div className={styles.reviewerRating}>
                                    {Array.from({ length: 5 }).map((_, i) => (
                                        i < review.rating ? <FaStar key={i} size={18} color="#FBBD34" /> : <FaRegStar key={i} size={18} />
                                    ))}
                                    <span>({review.rating})</span>
                                </div>
                            </Col>
                        ))}
                        {currentIndex < reviews.length - 2 && (
                            <Col md="1" className={styles.forwardArrowButton}>
                                <Button className={styles.arrowButton} onClick={scrollNext}>
                                    <IoCaretForwardCircleOutline size={40} />
                                </Button>
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>

            <Row className={styles.salesDataRow}>
                <h5 className={styles.sectionHeading}>Sales data</h5>
                <Col className={styles.salesDataColumn}>
                    <h5 className={styles.graphText}>Graph/Chart of Sales Over Time</h5>
                </Col>
            </Row>
        </div>
    )
}

export default PerformanceInsight;